/**
 * Created by Jerker Nord on 2018-05-31.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TweenLite} from "gsap";
import {IceIceYetiGameConfig} from "../../IceIceYetiGameConfig";
import {IceIceYetiGameModuleConfig} from "../../IceIceYetiGameModuleConfig";
import {IceIceYetiSoundConfig} from "../../IceIceYetiSoundConfig";
import {IceIceYetiParsedGameData} from "../../server/data/IceIceYetiParsedGameData";
import {IceIceYetiParsedInitData} from "../../server/data/IceIceYetiParsedInitData";
import {IReelsWin} from "../../server/IReelsWin";
import {IceIceYetiReelSymbol} from "../../symbol/IceIceYetiReelSymbol";
import {StickySymbol} from "../../symbol/StickySymbol";

export class IceIceYetiStickySymbolController extends ReelStopPresentationController {

    private _overlaySymbolsBeforeSpin:string[][];
    private _overlaySymbolsAfterSpin:string[][];
    private _putStickysOnReel:boolean = false;
    private _currentMode:string;
    private _stickyAttentionSound:string[] = [
        IceIceYetiSoundConfig.instance.STICKY_SYMBOL_ATTENTION_REEL_01,
        IceIceYetiSoundConfig.instance.STICKY_SYMBOL_ATTENTION_REEL_02,
        IceIceYetiSoundConfig.instance.STICKY_SYMBOL_ATTENTION_REEL_03,
        IceIceYetiSoundConfig.instance.STICKY_SYMBOL_ATTENTION_REEL_04,
        IceIceYetiSoundConfig.instance.STICKY_SYMBOL_ATTENTION_REEL_05
    ];
    private _stickyAttentionSoundPlaying:number = -1;
    private _winStickySyms:string[] = [];
    private _delayReels:boolean[];
    private _delayedSymbols:IceIceYetiReelSymbol[] = [];
    private _delayedSymbolsPlayed:string[] = [];

    constructor(index:number) {
        super(index, "IceIceYetiStickySymbolWPController");
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
    }

    private onRestore():void {
        for(let i:number = 0; i < this._overlaySymbolsBeforeSpin.length; i++) {
            for(let j:number = 0; j < this._overlaySymbolsBeforeSpin[i].length; j++) {
                let reelSymName:string = this._overlaySymbolsBeforeSpin[i][j];
                if(reelSymName && reelSymName !== "W") {
                    //Add sticky symbol to overlay layer (hidden at this point)
                    IceIceYetiGameModuleConfig.StickySymbolWPView.addNewStickySymbol(new StickySymbol(reelSymName), new PIXI.Point(i, j));
                }
            }
        }
        IceIceYetiGameModuleConfig.StickySymbolWPView.sortNewStickySymbols(true);
        IceIceYetiGameModuleConfig.StickySymbolWPView.getNewStickySymbolsTL().play();
        IceIceYetiGameModuleConfig.StickySymbolWPView.addNewStickysToAllStickys();
    }

    private onInitDataParsed(data:IceIceYetiParsedInitData) {
        this._overlaySymbolsBeforeSpin = data.overlaySymbolsBeforeSpin;
    }

    protected parseFeatureGameData(data:IceIceYetiParsedGameData):void {
        this._overlaySymbolsBeforeSpin = data.overlaySymbolsBeforeSpin;
        this._overlaySymbolsAfterSpin = data.overlaySymbolsAfterSpin;
        this._currentMode = data.mode;
        let reelsWin:IReelsWin[] = data.reelsWin;

        if((data.mode == GameMode.NORMAL && data.nextMode == GameMode.RESPIN) || (data.mode == GameMode.RESPIN && data.nextMode == GameMode.RESPIN) || (data.mode == GameMode.RESPIN && data.nextMode == GameMode.NORMAL)) {
            this._putStickysOnReel = true;
            this._delayReels = [false, false];
            for(let i:number = 0; i < reelsWin.length; i++) {
                if(this._winStickySyms.indexOf(reelsWin[i].symbolName) < 0) {
                    this._winStickySyms.push(reelsWin[i].symbolName);
                    this._delayReels[0] = this.hasWinOnReel(reelsWin[i].reelWinPositions[0]);
                    this._delayReels[1] = this.hasWinOnReel(reelsWin[i].reelWinPositions[1]);
                }
            }
        }
        if(data.mode == GameMode.RESPIN && data.nextMode == GameMode.NORMAL) {
            this._putStickysOnReel = false;
            this._winStickySyms = [];
            this._delayedSymbolsPlayed = [];
        }
    }

    private hasWinOnReel(reel:boolean[]):boolean {
        let win:boolean = false;
        for(let i:number = 0; i < reel.length; i++) {
            if(reel[i]) {
                win = true;
                break;
            }
        }
        return win;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._putStickysOnReel == true) {
            let tempReelSymName:string;
            let tempReelSymbol:IceIceYetiReelSymbol;
            for(let i:number = 0; i < this._overlaySymbolsAfterSpin[data.reelId].length; i++) {
                tempReelSymName = this._overlaySymbolsAfterSpin[data.reelId][i];
                if(tempReelSymName && tempReelSymName !== "W") {
                    tempReelSymbol = <IceIceYetiReelSymbol>Reels.getSymbol(data.reelId, i)!;
                    if(!this._overlaySymbolsBeforeSpin[data.reelId][i]) {
                        //Add new sticky symbol to overlay layer (hidden at this point)
                        IceIceYetiGameModuleConfig.StickySymbolWPView.addNewStickySymbol(new StickySymbol(tempReelSymName), new PIXI.Point(data.reelId, i));

                        //Don't give away the respin by highlightning the syms on first spin
                        if(this._currentMode == GameMode.RESPIN) {
                            this.playStickyAttentionSound(data.reelId);
                            if(data.reelId < 2) {
                                this.checkForAttentionDelay(tempReelSymbol, data.reelId);
                            } else if(data.reelId > 1) {
                                this.playDelayedSymbols();
                                tempReelSymbol.changeState({state : IceIceYetiGameConfig.instance.SYMBOL_STATES.stickyAttention});
                            }
                        } else {
                            // Not really played on first respin, but we need to keep track of if for next respins
                            this.addDelayedSymbolPlayed(tempReelSymbol.symName);
                        }
                    } else {
                        //Fade out syms under sticky syms
                        if(this._gameData!.nextMode! == GameMode.RESPIN) {
                            TweenLite.to(tempReelSymbol, 0.2, {alpha : 0});
                        } else {
                            //Respin is over. Let's put the sticky symbols on the reels
                            tempReelSymbol.replaceWith(tempReelSymName, data.reelId, IceIceYetiGameConfig.instance.SYMBOL_STATES.frozen);
                        }
                    }
                }
            }
        }
        this.dispatchCompleteEvent(data.reelId);
    }

    private playStickyAttentionSound(reelId:number):void {
        if((reelId < 2 && this._delayReels[reelId] == false) || reelId > 1) {
            if(this._stickyAttentionSoundPlaying < reelId) {
                SlotGame.sound.playEffect(this._stickyAttentionSound[reelId]);
                this._stickyAttentionSoundPlaying = reelId;
            }
        }
    }

    private checkForAttentionDelay(symbol:IceIceYetiReelSymbol, reelId:number):void {
        if(this._delayReels[reelId] && this._delayedSymbolsPlayed.indexOf(symbol.symName) < 0) {
            this._delayedSymbols.push(symbol);
        } else {
            symbol.changeState({state : IceIceYetiGameConfig.instance.SYMBOL_STATES.stickyAttention});
        }
    }

    private playDelayedSymbols():void {
        let tempSym:IceIceYetiReelSymbol;
        while(this._delayedSymbols.length > 0) {
            tempSym = this._delayedSymbols.pop()!;
            this.addDelayedSymbolPlayed(tempSym.symName);
            tempSym.changeState({state : IceIceYetiGameConfig.instance.SYMBOL_STATES.stickyAttention});
        }
    }

    private addDelayedSymbolPlayed(symName:string):void {
        if(this._delayedSymbolsPlayed.indexOf(symName) < 0) {
            this._delayedSymbolsPlayed.push(symName);
        }
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(this._putStickysOnReel == true) {
            if(data.reelId == 4) {
                //Spin is completed, sort new sticky sym animations (if any)
                IceIceYetiGameModuleConfig.StickySymbolWPView.sortNewStickySymbols();
                this._stickyAttentionSoundPlaying = -1;
            }
        }
        this.dispatchCompleteEvent(data.reelId);
    }
}